import { render, staticRenderFns } from "./PrintEditor.vue?vue&type=template&id=e0a890ba"
import script from "./PrintEditor.vue?vue&type=script&lang=js"
export * from "./PrintEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports